// Compliance data models adapted from Flutter version
import { ComplianceDocument } from './ComplianceDocument';

export class ComplianceData {
  constructor({
    uuid = '',
    status = '',
    entityType = '',
    country = '',
    entityId = '',
    documents = [],
    notes = [],
  }) {
    this.uuid = uuid;
    this.status = status;
    this.entityType = entityType;
    this.country = country;
    this.entityId = entityId;
    this.documents = documents.map((doc) => new ComplianceDocument(doc));
    this.notes = notes;
  }

  static fromMap(data = {}) {
    return new ComplianceData({
      uuid: data.uuid || '',
      status: data.status || '',
      entityType: data.entityType || '',
      country: data.country || '',
      entityId: data.entityId || '',
      documents: (data.documents || []).map((doc) => ComplianceDocument.fromMap(doc)),
      notes: data.notes || [],
    });
  }
}

export default ComplianceData;
